import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './HowItWorks.module.css';

const MainTitle = ({ title, subTitleLine }) => (
  <div className={styles.mainTitleWrapper}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    <p className={styles.sectionSubtitle}>{subTitleLine}</p>
  </div>
);

const SearchIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21 21L16.65 16.65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CartIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GrowthIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 6L13.5 15.5L8.5 10.5L1 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17 6H23V12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UserIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShippingIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 16V4H4V16H16Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16 8H20L22 10V16H16V8Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MessageIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DeliveryIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 6V12L16 14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StarIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LoginIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 7H16V17H3V7Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16 10H19L21 13V17H16V10Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="6.5" cy="19.5" r="1.5" fill="white" stroke="white" strokeWidth="1.5" />
    <circle cx="17.5" cy="19.5" r="1.5" fill="white" stroke="white" strokeWidth="1.5" />
  </svg>
);

const CameraIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NotificationIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PrinterIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 9V2H18V9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 14H6V22H18V14Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MoneyIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 1V23" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReturnIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5L3 12L9 19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12H21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function HowItWorks() {
  return (
    <section className={styles.howItWorks} id="howItworksId">
      <div className={styles.containerCustom}>
        <div className="">
          <MainTitle
            title={<FormattedMessage id="HowItWorks.title" />}
            subTitleLine={<FormattedMessage id="HowItWorks.subtitle" />}
          />
        </div>

        <div className={styles.categoriesContainer}>
          <div className={styles.category}>
            <h2 className={styles.categoryTitle}>
              <FormattedMessage id="HowItWorks.renters.title" />
            </h2>
            <div className={styles.stepsContainer}>
              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <SearchIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step1.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step1.description" />
                </p>
              </div>

              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <StarIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step2.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step2.description" />
                </p>
              </div>

              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <MessageIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step3.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step3.description" />
                </p>
              </div>

              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <DeliveryIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step4.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step4.description" />
                </p>
              </div>

              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <ReturnIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step5.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step5.description" />
                </p>
              </div>

              <div className={styles.step}>
                <div className={styles.stepIcon}>
                  <DeliveryIcon className={styles.icon} />
                </div>
                <h3 className={styles.stepTitle}>
                  <FormattedMessage id="HowItWorks.renters.step6.title" />
                </h3>
                <p className={styles.stepDescription}>
                  <FormattedMessage id="HowItWorks.renters.step6.description" />
                </p>
              </div>
            </div>
          </div>

          <div className={styles.lendersSection}>
            <div className={styles.category}>
              <h2 className={styles.categoryTitle}>
                <FormattedMessage id="HowItWorks.lenders.title" />
              </h2>
              <div className={styles.stepsContainer}>
                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <UserIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step1.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step1.description" />
                  </p>
                </div>

                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <CameraIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step2.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step2.description" />
                  </p>
                </div>

                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <LoginIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step3.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step3.description" />
                  </p>
                </div>

                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <NotificationIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step4.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step4.description" />
                  </p>
                </div>
              </div>

              <div className={styles.stepsContainer} style={{ marginTop: '30px' }}>
                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <PrinterIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step5.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step5.description" />
                  </p>
                </div>

                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <MoneyIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step6.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step6.description" />
                  </p>
                </div>

                <div className={styles.step}>
                  <div className={styles.stepIcon}>
                    <GrowthIcon className={styles.icon} />
                  </div>
                  <h3 className={styles.stepTitle}>
                    <FormattedMessage id="HowItWorks.lenders.step7.title" />
                  </h3>
                  <p className={styles.stepDescription}>
                    <FormattedMessage id="HowItWorks.lenders.step7.description" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
